import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Home as HomeIcon } from 'lucide-react';
import { Button } from './ui/button';

// Logo Pam Immobilier
const LOGO_URL = 'https://customer-assets.emergentagent.com/job_realty-preview-2/artifacts/t4dikgev_image.png';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Accueil', path: '/' },
    { name: 'À propos', path: '/a-propos' },
    { name: 'À vendre', path: '/a-vendre' },
    { name: 'Vendus', path: '/vendus' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white shadow-md py-2'
          : 'bg-white py-3'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link
            to="/"
            className="flex items-center gap-3 group"
          >
            <img 
              src={LOGO_URL} 
              alt="Pam Immobilier" 
              className="h-20 md:h-24 w-auto object-contain"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`relative font-medium transition-colors duration-300 text-gray-700 hover:text-[#8B2942] ${
                  location.pathname === link.path 
                    ? 'font-semibold text-[#8B2942] after:absolute after:bottom-[-4px] after:left-0 after:w-full after:h-0.5 after:bg-[#8B2942]'
                    : ''
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Button
              asChild
              className="bg-[#8B2942] hover:bg-[#6d2033] text-white transition-all duration-300"
            >
              <Link to="/vendre-votre-bien" className="flex items-center gap-2">
                <HomeIcon className="w-4 h-4" />
                Vendre votre bien
              </Link>
            </Button>
            <Button
              asChild
              className="bg-[#8B2942] hover:bg-[#6d2033] text-white transition-all duration-300"
            >
              <Link to="/contact" className="flex items-center gap-2">
                <Phone className="w-4 h-4" />
                Me contacter
              </Link>
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 mr-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6 text-[#8B2942]" />
            ) : (
              <Menu className="w-6 h-6 text-[#8B2942]" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 border-t border-gray-200 pt-4 animate-in slide-in-from-top-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block py-3 font-medium text-[#8B2942] ${
                  location.pathname === link.path ? 'font-bold' : ''
                }`}
              >
                {link.name}
              </Link>
            ))}
            
            {/* Mobile Buttons */}
            <div className="mt-4 space-y-3">
              <Button
                asChild
                className="w-full bg-[#8B2942] hover:bg-[#6d2033] text-white"
              >
                <Link 
                  to="/vendre-votre-bien" 
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="flex items-center justify-center gap-2"
                >
                  <HomeIcon className="w-4 h-4" />
                  Vendre votre bien
                </Link>
              </Button>
              <Button
                asChild
                className="w-full bg-[#8B2942] hover:bg-[#6d2033] text-white"
              >
                <Link 
                  to="/contact" 
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="flex items-center justify-center gap-2"
                >
                  <Phone className="w-4 h-4" />
                  Me contacter
                </Link>
              </Button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
